import { string } from 'prop-types'

import setInnerHTML from 'views/utils/setInnerHTML'

/**
 * Component allows to embed translated text containing markup.
 * @deprecated use `Trans` from `@lingui/react`, read docs https://lingui.dev/ref/react#trans
 *
 * @param {Object} props
 * @param {string} props.text Translated text with markup
 * @param {React.ReactNode} props.element Element in which a translated string to be inserted
 * @param {String} props.className
 */
const TransWithHtml = ({ text, element: Component, className }) => (
  <Component {...setInnerHTML(text)} className={className} />
)

TransWithHtml.propTypes = {
  text: string.isRequired,
  element: string,
  className: string,
}

TransWithHtml.defaultProps = {
  className: null,
  element: 'span',
}

export default TransWithHtml
